import axios from "axios";
import { useAuth } from "../context/AuthContext";

const useAxios = () => {
  const { auth, logout } = useAuth();  // <-- get auth
  const accessToken = auth?.accessToken; // <-- extract token safely

  console.log("🔧 Axios instance created with accessToken:", accessToken);

  const instance = axios.create({
    baseURL: "https://api.adanapaints.com/api",
  });

  // const instance = axios.create({
  //   baseURL: "http://localhost:8080/api",
  // });


  instance.interceptors.request.use((config) => {
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  });

  instance.interceptors.response.use(
    (res) => res,
    (err) => {
      if (err.response?.status === 401) {
        logout();
      }
      return Promise.reject(err);
    }
  );

  return instance;
};

export default useAxios;
